
import Vue from "vue";

import Utils from "@/assets/js/Utils";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
export default Vue.extend({
  data() {
    return {
      dialog: null as any,
      logs: [] as any[],
      alarms: [] as any[],
      currentId: "log",
      count: 50,
      page: 0,
      page1: 0,
      sid: "" as string,
    };
  },
  mounted() {
    this.dialog = this.$refs.dialog;
    this.page = 0;
    this.page1 = 0;
    this.handleClick();
  },
  methods: {
    opened() {
      this.$emit("opened");
    },
    show(sid: string) {
      this.sid = sid;
      this.page = 0;
      this.page1 = 0;
      this.logs = [];
      this.alarms = [];
      this.handleClick();
    },
    hiden() {
      this.dialog.hiden();
    },
    more(type: number) {
      if (type == 0) {
        this.page += 1;
        this.selectLog();
      } else {
        this.page1 += 1;
        this.selectAlarm();
      }
    },
    async selectLog() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetLightLogSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.logs.push(x);
      });
    },
    async selectAlarm() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };

      if (!this.sid || this.sid.length == 0) {
        return;
      }
      obj.skip = this.page1 * this.count;
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarmSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.alarms.push(x);
      });
    },
    async handleClick() {
      console.log(this.currentId);
      if (this.currentId == "log") {
        this.page = 0;
        this.logs = [];
        await this.selectLog();
      } else {
        this.page1 = 0;
        this.alarms = [];
        await this.selectAlarm();
      }
    },
  },
});
